export default __webpack_public_path__ + "static/about-11-a737d841b7a4ca708e4dd1dd96ef27ce.jpeg";